// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__Wqa5U","corectMesage":"LoginForm_corectMesage__K55iu","errorMessage":"LoginForm_errorMessage__55oNp"};